<template lang="pug">
.copy(:class="{ selected, urls: url && copyUrls }")
  .paper(@click.stop.prevent="click", title="Copy to clipboard")
    .line
    .line
    .paper
      .line
      .line
  .angles(v-if="url && copyUrls") &lt;/&gt;
  .url-mode-toggle(v-if="url", @click.stop.prevent="copyUrls = !copyUrls", :title="`switch to copying ${ copyUrls && 'text' || 'urls' }`") &lrarr;
  slot
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { vuexComputed } from '@/helpers';
import { copyDom } from '@livelybone/copy';
export default {
  name: 'clipboard',
  props: {
    id: String,
    text: String,
    index: Number,
    items: Array,
    url: String,
    date: String,
    pub: String
  },
  computed: {
    ...mapGetters(['clipboardText', 'clipboardHTML']),
    ...vuexComputed('onClipboard', 'copyImage', 'loadingImages', 'copyUrls'),
    selected() {
      const { onClipboard, id, items, allSelected } = this;
      return (items && allSelected) || onClipboard[id];
    },
    allSelected() {
      const { items, onClipboard } = this;
      if (items) {
        //console.log(onClipboard, items?.map(([id]) => id), items?.map(([id]) => id).reduce((map, id) => map && onClipboard[id], true));
      }
      return items?.map(([id]) => id).reduce((map, id) => map && onClipboard[id], true);
    }
  },
  methods: {
    ...mapActions(['setPending', 'itemCopied']),
    async click({  metaKey }) {
      const { onClipboard, id, text, index, textForClipboard, items, allSelected, loadingImages, setPending, url, copyUrls, date, pub, itemCopied } = this;
      //console.log('onClipboard', onClipboard, onClipboard[id]);
      let clipboard;
      itemCopied([id, (text || '').substr(0, 240)]);
      console.log('metaKey', metaKey);
      //todo: investigate why meta copies in link format
      const href = `${ location.origin }${ url }`;
      if (items) {
        clipboard = { ...(metaKey && onClipboard || {}) };
        items.forEach(([id, text, index, date, url]) => clipboard[id] = (allSelected ? undefined : { text: copyUrls && href || text, index, date, pub, url }));
      } else {
        console.log('clip date', date);
        clipboard = { ...(metaKey && onClipboard || {}), [id]: onClipboard[id] ? undefined : { text: copyUrls && href || text, index, date, pub, url: url && href || undefined } };
      }
      await (this.onClipboard = clipboard);
      const copyImage = this.copyImage = /^img\:/.test(text);
      if (copyImage) {
        //copy(text.replace(/^img\:/, ''));
        const reg = /img\:https\:\/\/content\.weave\.ai\/picture\-images\/(.+)\-(\d+).png/;
        const [did, pgn] = text.replace(reg, '$1|$2').split('|');
        const highResUrl = `https://d2ks69eyvb68ub.cloudfront.net/api/GetDocProcPdfThumbnail?did=${ did }&page=${ pgn }`;
        console.log('loaded?', loadingImages[highResUrl] !== 'loaded', highResUrl);
        if (loadingImages[highResUrl] !== 'loaded') {
          console.log('setting to pending', highResUrl);
          setPending(highResUrl);
        }
        copyDom(document.querySelector('.clipboard-images > div'), { clearSelect: true });
        console.log('copy image success');
      } else {
        if (1 > 0) {
          copyDom(document.querySelector('.clipboard-images > div'), { clearSelect: true });
        } else {
          const tfc = textForClipboard(clipboard);
          if (tfc) {
            try {
              //console.log('trying to copy...', clipboardText);
              // const div = document.createElement('div');
              // div.innerHTML = clipboardHTML;
              // await this.$copyText(div);
              await this.$copyText(tfc);
              console.log('success');
            } catch (ex) {
              console.log('fail', ex);
            }
          }
        }
      }
    },
    clipboardItems(clipboard) {
      return Object.values(clipboard).filter(v => v).sort((a, b) => a.index - b.index);
    },
    textForClipboard(clipboard) {
      const { clipboardItems } = this;
      const ci = clipboardItems(clipboard);
      return ci && ci.length && ci.filter(({ text }) => !/^img\:/.test(text)).map(({ text }) => text).join('\n\n') || '';
    },
    HTMLForclipboard(clipboard) {
      const { clipboardItems } = this;
      const ci = clipboardItems(clipboard);
      return ci && ci.length && ('<table>' + ci.map(({ text }) => `<tr><td>${ text }</td></tr>`).join('') + '</table>') || '';
    }
  }
};
// function copy(src) {
//   try {
//     const img = document.createElement('img');
//     img.src = src;
//     document.body.appendChild(img);
//     let myRange;
//     if (document.createRange) {
//       myRange = document.createRange();
//       myRange.setStartBefore(img);
//       myRange.setEndAfter(img);
//       myRange.selectNode(img);
//     }
//     else
//     {
//       console.log('clipboard not supported');
//     }
//     /*
//     if (document.body.createControlRange)
//     {
//       console.log('ControlRange work');
//       const controlRange = body.createControlRange();
//       controlRange.add(img);
//       controlRange.execCommand('Copy', false, null);
//     }
//     else
//     {
//       console.log('ControlRange NOT work');
//     }
//     */
//     window.getSelection().addRange(myRange);
//     const success = document.execCommand('copy');
//     console.log(success && 'success' || 'fail');
//     document.body.removeChild(img);
//     //document.getElementById('answer').innerHTML="Copy image command was " + msg ;
//   } catch (ex) {
//     console.log('copyImage fail');
//   }
// }
</script>
<style lang="scss" scoped>
@import '../scss/global';
.copy {
  text-align: left;
  position: relative;
  &.selected {
    .paper {
      opacity: 1 !important;
      //border-color: black;
      .line {
        //background-color: black;
        &::after {
          //background-color: black;
        }
      }
    }
    & > .angles {
      opacity: 1 !important;
      color: black;
    }
  }
  &.urls {
    .paper {
      > .line {
        opacity: 0;
      }
    }
  }
  .paper {
    opacity: 0.35;
    width: 2rem;
    height: 2.75rem;
    border: 2px solid black;
    border-radius: 3px;
    position: relative;
    top: 1rem;
    left: 1rem;
    background-color: white;
    transform: scale(0.4);
    transform-origin: center;
    cursor: pointer;
    > .line {
      position: absolute;
      top: 20%;
      left: 0.25rem;
      right: 0.25rem;
      height: 2px;
      background: black;
      & + .line {
        top: 60%;
      }
      &::after {
        content: '\00a0';
        position: absolute;
        top: 0.5rem;
        width: 100%;
        height: 2px;
        background: black;
      }
    }
    & > .paper {
      transform: scale(1);
      position: absolute;
      top: -0.6rem;
      left: -0.75rem;
      opacity: 1 !important;
    }
  }
  &:hover {
    & > .angles {
      //color: black;
      opacity: 1;
    }
    & > .url-mode-toggle {
      opacity: 1;
      &:hover {
        color: black;
      }
    }
  }
  & > .angles {
    position: absolute;
    top: 2rem;
    left: 1.5rem;
    color: $brn;
    background-color: white;
    font-size: 0.5rem;
    font-weight: 600;
    pointer-events: none;
    opacity: 0;
  }
  & > .url-mode-toggle {
    cursor: pointer;
    position: absolute;
    top: 1.75rem;
    left: 100%;
    background-color: white;
    //z-index: -1;
    transform: translate3d(0.5rem, 0, 0);
    opacity: 0;
    color: rgba(black, 0.35);
  }
}
</style>